import { RichRuler } from '../RichRuler';

class RichAngleBoxRuler extends RichRuler {

}

export {
  RichAngleBoxRuler,
};
